import React from 'react';

export const sectionHeaderStyle: React.CSSProperties = {
  fontSize: '12px',
  textTransform: 'uppercase',
  color: '#888',
  marginBottom: '10px',
  marginTop: '20px',
  fontWeight: 'bold',
  letterSpacing: '1px'
};

export const buttonStyle: React.CSSProperties = {
  display: 'block',
  width: '100%',
  padding: '8px 12px',
  marginBottom: '8px',
  background: 'rgba(255, 255, 255, 0.05)',
  border: '1px solid rgba(255, 255, 255, 0.1)',
  borderRadius: '4px',
  color: '#ecf0f1',
  cursor: 'pointer',
  textAlign: 'left',
  fontSize: '13px',
  transition: 'all 0.2s'
};

export const primaryButtonStyle: React.CSSProperties = {
  ...buttonStyle,
  background: '#3498db',
  borderColor: '#2980b9',
  fontWeight: 'bold',
  textAlign: 'center'
};

export const selectStyle: React.CSSProperties = {
  width: '100%',
  padding: '8px',
  marginBottom: '8px',
  background: 'rgba(0, 0, 0, 0.3)',
  border: '1px solid rgba(255, 255, 255, 0.1)',
  borderRadius: '4px',
  color: 'white',
  fontSize: '12px'
};

export const resultItemStyle = (passed: boolean): React.CSSProperties => ({
  padding: '8px',
  marginBottom: '4px',
  background: passed ? 'rgba(46, 204, 113, 0.1)' : 'rgba(231, 76, 60, 0.1)',
  border: `1px solid ${passed ? 'rgba(46, 204, 113, 0.3)' : 'rgba(231, 76, 60, 0.3)'}`,
  borderRadius: '4px',
  fontSize: '11px'
});
